module.exports = __webpack_public_path__ + "static/media/matilde-cap-brazil-normal.936f964c.png";